import { FC } from 'react';
import MainLayout from 'components/main-layout/MainLayout';
import { useQuery } from 'react-query';
import { useParams } from 'react-router';
import API from 'core/Api';
import IResponseData from 'types/api';
import { useActiveClientContext } from 'store/active-client';
import { buildClientEntity } from 'utils/helpers/client';
import EditForm from './EditForm';
import { IDropdowns, IField } from '../types';

export interface IProps {
  fieldsEntityName: string;
  fieldsEntityEndpoint: string;
  fieldsDropdownsEntityName: string;
  fieldsDropdownsEntityEndpoint: string;
}

const Edit: FC<IProps> = ({
  fieldsEntityName,
  fieldsEntityEndpoint,
  fieldsDropdownsEntityName,
  fieldsDropdownsEntityEndpoint,
}) => {
  const { id } = useParams<{ id: string | undefined }>();
  const { client } = useActiveClientContext();

  const { isLoading, error, data } = useQuery<IField, Error>(
    [buildClientEntity(fieldsEntityName, client), { id }],
    (): Promise<IField> =>
      API.get<IResponseData<IField>>(fieldsEntityEndpoint).then(res =>
        res.data.totalCount > 1
          ? (res.data?.items.filter(item => item.id.toString() === id)[0] as IField)
          : res.data?.items[0]
      )
  );
  const {
    isLoading: isLoadingFieldDropdowns,
    error: errorFieldDropdowns,
    data: dropdowns,
  } = useQuery<IDropdowns, Error>([buildClientEntity(fieldsDropdownsEntityName, client)], (): Promise<IDropdowns> => {
    return API.get(fieldsDropdownsEntityEndpoint).then(res => res.data && res.data);
  });

  return (
    <MainLayout
      title="Редактиране на поле"
      isLoading={isLoading && isLoadingFieldDropdowns}
      error={error || errorFieldDropdowns}
    >
      {dropdowns && data && (
        <EditForm
          fieldsEntityName={fieldsEntityName}
          field={data}
          fieldDataOptions={dropdowns}
        />
      )}
    </MainLayout>
  );
};

export default Edit;
